// extracted by mini-css-extract-plugin
module.exports = {"list":"e_c1","button":"e_d1"};